// ⚠️ AUTO-GENERATED FROM CORE REPO
// DO NOT EDIT — changes will be overwritten

if (!customElements.get('core-fitting-badge')) {
  customElements.define('core-fitting-badge', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        if (!this.initialized) {
          this.initialized = true;
          const words = this.textContent.trim().split(/\s+/);
          this.replaceChildren();
          words.forEach((word, index) => {
            if (index) this.append(document.createTextNode(' '));
            const span = document.createElement('span');
            span.textContent = word;
            this.append(span);
          });
        }
        this.observer ||= new ResizeObserver(() => this.scheduleFit());
        this.observer.observe(this.parentElement);
        this.onFontsLoaded ||= () => this.scheduleFit();
        document.fonts?.addEventListener('loadingdone', this.onFontsLoaded);
        document.fonts?.ready.then(() => this.scheduleFit());
        this.scheduleFit();
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      document.fonts?.removeEventListener('loadingdone', this.onFontsLoaded);
    }

    scheduleFit() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.fit());
    }

    fit() {
      if (!this.clientWidth) return;
      const parent = getComputedStyle(this.parentElement);
      const height = this.parentElement.clientHeight - parseFloat(parent.paddingTop) - parseFloat(parent.paddingBottom);
      const maximum = parseFloat(parent.fontSize);
      if (height <= 0 || !Number.isFinite(maximum)) return;
      const fits = size => {
        this.style.fontSize = `${size}px`;
        return this.scrollWidth <= this.clientWidth && this.scrollHeight <= height;
      };
      if (fits(maximum)) return;
      let low = 0;
      let high = maximum;
      for (let i = 0; i < 12; i++) {
        const middle = (low + high) / 2;
        if (fits(middle)) low = middle;
        else high = middle;
      }
      this.style.fontSize = `${Math.floor(low * 100) / 100}px`;
    }
  });
}
